import { useEffect } from 'react';
import { useEnvProvider } from '@bechtel/client-common';

export const AuthRequest = () => {
  const { envConfig } = useEnvProvider();

  useEffect(() => {
    if (!envConfig || !envConfig.authUri) return;
    location.href = envConfig.authUri;
  }, [envConfig.authUri]);
  return null;
};
